import styled from "styled-components";
import { HeadingRowStyled } from "styles/common.styles";
import { ClickableTableWrapperStyled } from "../sharedTable.styles";

// Fills the remaining height of the page card so the active tab pane becomes
// a flex column and the table wrapper inside it owns the scroll — the same
// full-height table behavior as /talent-mobility, where the wrapper is a
// direct child of the card.
// antd v6 Tabs DOM: .ant-tabs > .ant-tabs-nav + .ant-tabs-body-holder >
// .ant-tabs-body > .ant-tabs-content (one per pane; -active marks the
// visible one — v5's content-holder/tabpane classes no longer exist).
export const TabsBodyStyled = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0 24px;

  .ant-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .ant-tabs-nav {
    flex-shrink: 0;
  }

  .ant-tabs-body-holder,
  .ant-tabs-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ant-tabs-content {
    height: 100%;
    min-height: 0;
  }

  .ant-tabs-content-active {
    display: flex;
    flex-direction: column;
  }
`;

// antd has no prop that pins the pagination bar to the container bottom — the
// pager flows right after the last row, so a short page of rows would leave
// it mid-card. Stretching the table block (wrapper → spin layers → table)
// pushes the pager to the card bottom regardless of row count; the shared
// wrapper's sticky rules still handle the overflowing case unchanged.
// antd v6 spin DOM: .ant-table-wrapper > .ant-spin > .ant-spin-container.
export const PlanTableWrapperStyled = styled(ClickableTableWrapperStyled)`
  .ant-table-wrapper {
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

  .ant-table-wrapper > .ant-spin,
  .ant-spin-container {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .ant-spin-container > .ant-table {
    flex: 1;
  }
`;

export const DetailHeadingRowStyled = styled(HeadingRowStyled)`
  margin: 8px 0;
`;

// Right-hand side of a suggested-role row — SMI tag + action.
export const RowActionsStyled = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
`;
